import App from './App';

export { App };



// WEBPACK FOOTER //
// ./src/comparison-predefined/containers/index.js